
import * as angular from "angular";
import "angular-material";

import { CurrentUserService } from "@services/currentUser.service";
import { IUser } from "@interfaces/IUser";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { UsersService } from "@services/users.service";
import { IHttpException } from "@interfaces/IHttpException";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { AccountService } from "@services/account.service";

import "./account.scss";

export class AccountController {

    errorMessage: string;

    newPassword1: string;
    newPassword2: string;

    currentUser: IUser;

    companyImage: string;

    preventDialogFromClosing = false;

    saving: boolean;
    selectedTab = 0;

    static $inject = ["$rootScope", "$q", "$mdDialog", "$timeout", "accountService", "usersService", "currentUserService", "passwordReset", "emailRequired"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        private readonly $q: angular.IQService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly $timeout: angular.ITimeoutService,
        private readonly accountService: AccountService,
        private readonly usersService: UsersService,
        private readonly currentUserService: CurrentUserService,
        private readonly passwordReset: boolean,
        private readonly emailRequired: boolean) {

        if (passwordReset || emailRequired) {
            this.preventDialogFromClosing = true;
        }

        if (passwordReset) {
            this.selectedTab = 1;
        }

        this.currentUser = angular.copy($rootScope.currentUser);
    }

    hide() {
        if (!this.preventDialogFromClosing) {
            this.$mdDialog.hide();
        }
    }

    onCompanyImageChanged(event: any) {
        this.companyImage = event.fileString;
    }

    saveChanges() {
        this.saving = true;

        if (this.newPassword1 && this.newPassword2) {
            this.currentUser.ResetPassword = false;
        }

        const detailsPromise = this.usersService.save(this.currentUser);
        let passwordPromise = this.$q.when();
        let imagePromise = this.$q.when();

        // Only update password if it has been set
        if (this.newPassword1 && this.newPassword2) {
            passwordPromise = this.accountService.changePassword(this.newPassword1);
            passwordPromise.then(() => {
                if (this.passwordReset) {
                    this.preventDialogFromClosing = false;
                }
            });
        }

        detailsPromise.then(() => {
            if (this.emailRequired) {
                this.preventDialogFromClosing = false;
            }
        });

        // Only update image if it has not been set
        if (this.companyImage) {
            imagePromise = this.accountService.setAccountImage(this.companyImage);
        }

        // Wait for all saving events to complete
        this.$q.all([detailsPromise, passwordPromise, imagePromise])
            .then(() => {
                var alert = this.$mdDialog
                    .alert()
                    .title("Details Changed")
                    .ok("Close")
                    .textContent("Your account details have been successfully updated");

                this.currentUserService.getCurrentUser();

                if (this.companyImage) {
                    this.$rootScope.$broadcast(BroadcastEvent.updateAccountImage);
                }

                this.$mdDialog.show(alert);

                this.newPassword1 = "";
                this.newPassword2 = "";

                this.errorMessage = "";
            })
            .catch((a: angular.IHttpPromiseCallbackArg<IHttpException>) => {

                this.errorMessage = `Unable to save: ${a.data.ExceptionMessage}`;
            })
            .finally(() => {
                this.saving = false;
            });
    }
}
